(function ($) {
  window.MealProgram = {
    //DOM nodes
    $qsMealsBlock: null,
    $qsMealsBlockCTA: null,
    $qsDirectToCartCTA: null,
    $qsMealsDirectAddToCart: null,
    $qsDietId: null,
    $qsAdditivesHeaderPrice: null,
    initNodes: function () {
      this.$qsMealsBlock = $('#qs-leftover');
      this.$qsMealsBlockCTA = $('#qs-cta-true');
      this.$qsDirectToCartCTA = $('#qs-cta-dtc');
      this.$qsMealsDirectAddToCart = $('#qs-cta-false');
      this.$qsDietId = $('#dietitian_yes');
      this.$qsDiscountCode = $('#discount_qs');
      this.$qsAdditivesHeaderPrice = $('#additivies_price');
      this.$qsCTA = $('#product-form-cart-meals');
      this.$qsProgramTitle = $('#qs-ttl');
    },
    toggleMealsBlock: function () {
      var $this = this;
      if (!$this.$qsMealsBlock.length) return;

      $this.$qsMealsBlockCTA.on('click', function () {
        $this.$qsMealsBlock.toggleClass('active');
        $this.$qsMealsBlockCTA.toggleClass('active');
        $this.$qsAdditivesHeaderPrice.toggleClass('active');

        if ($this.$qsMealsBlockCTA.hasClass('active')) {
          var topPosition = $this.$qsMealsBlockCTA.offset().top;
          $('html, body').animate({ scrollTop: topPosition }, 'slow');
        }
      });
    },
    addToCartSingleDietitian: function () {
      var $this = this;
      const { MHProductsCollections } = window;
      const programTitle = $this.$qsProgramTitle[0].innerHTML.split(' ')[0];
      const { sellingPlanFirstId } = MHProductsCollections.find(({ title }) => title.includes(programTitle));


      $this.$qsDirectToCartCTA.on('click', function () {
        if (typeof window.CartUtil === 'undefined') return;

        const dietPropeties = {
          _shipping_interval_unit_type: 'Weeks',
          _shipping_interval_frequency: '6',
        };

        $this.$qsDirectToCartCTA.addClass('loading').attr('disabled', true);
        window.CartUtil.addItem(1, $this.$qsDietId.val(), dietPropeties, sellingPlanFirstId, function () {
          window.location = '/cart';
        });
      });
    },
    redeemDiscount: function () { 
      if (!this.$qsDiscountCode.length) return;
      var discountCode = this.$qsDiscountCode.val();

      this.$qsCTA.on('click', function () {
        if (typeof window.Cookies !== 'undefined') {
          window.Cookies.set('mhDiscount', discountCode, { expires: 1 });
        }
      });
    },
    init: function () {
      if (!$('#qs-leftover').length) return;
      this.initNodes();
      this.toggleMealsBlock();
      this.addToCartSingleDietitian();
      this.redeemDiscount();
    },
  };
})(jQuery);
